import { useEffect, useState } from "react";

import toast from "react-hot-toast";
import CancelButton from "../../../../components/admin/usable/CancelButton";
import AddButton from "../../../../components/admin/usable/AddButton";
import EditButton from "../../../../components/admin/usable/actions/EditButton";
import DeleteButton from "../../../../components/admin/usable/actions/DeleteButton";
import TableLoader from "../../../../components/admin/usable/TableLoader";
import {
  addFacility,
  deleteFacility,
  getFacilities,
  updateFacility,
} from "../../../../api/admin/facility";
import { useDispatch, useSelector } from "react-redux";
import {
  setForAll,
  setIsSingleSelected,
  setShowFileUploader,
  setSingleSelected,
} from "../../../../redux/admin/fileManagerSlice";
import FileUploadandSelect from "../../../../components/admin/usable/fileuploader/FileUploadandSelect";

const Facilities = () => {
  const [FacilityData, setFacilityData] = useState([]);
  const [FormData, setFormData] = useState({
    id: null,
    facilityName: "",
    icon: "",
    status: 1,
    createdAt: new Date().toISOString(),
  });
  const { showFileUploader, singleSelected } = useSelector(
    (state) => state.file,
  );
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setForAll(true));
    dispatch(setIsSingleSelected(true));

    return () => {
      dispatch(setForAll(false));
      dispatch(setIsSingleSelected(false));
    };
  }, [dispatch]);

  useEffect(() => {
    if (singleSelected) {
      setFormData((prevData) => ({
        ...prevData,
        icon: singleSelected.fileLink.medium || "",
      }));
      dispatch(setSingleSelected(null));
    }
  }, [singleSelected, dispatch]);
  useEffect(() => {
    getFacilities(setFacilityData);
  }, []);
  const handleUpload = () => {
    dispatch(setShowFileUploader(true));
    dispatch(setForAll(true));
  };
  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [id]: value,
    }));
  };
  const handleEdit = (item) => {
    setFormData({
      id: item.id,
      facilityName: item.facilityName,
      icon: item.icon,
      status: item.status,
      createdAt: item.createdAt,
    });
  };
  const handleDelete = (item) => {
    const id = item.id;
    deleteFacility(id, setFacilityData);
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (FormData.id) {
      updateFacility(FormData, setFormData, setFacilityData);
    } else {
      if (FormData.facilityName !== "") {
        addFacility(FormData, setFormData, setFacilityData);
      } else {
        toast.error("Enter Facility Name");
      }
    }
  };
  const handleClear = () => {
    setFormData({
      id: null,
      facilityName: "",
      icon: "",
      status: 1,
      createdAt: new Date().toISOString(),
    });
  };
  return (
    <>
      {showFileUploader && <FileUploadandSelect />}
      <div className="p-0 lg:p-5  space-y-5">
        <div>
          <p className="font-bold">Facilities</p>
        </div>
        <div className="flex flex-wrap gap-5">
          <div className="w-[400px] h-[310px] border  p-3 bg-white rounded-lg">
            <div>
              <p className="text-sm font-bold pb-3">
                {FormData.id ? "Edit Facility" : "Add Facility"}
              </p>
            </div>

            <div className="space-y-6">
              <div>
                <label className="text-xs">Facility Name</label>
                <input
                  type="text"
                  className="w-full px-4 py-2 rounded-lg border focus:outline-none text-xs"
                  placeholder="Facility Name"
                  id="facilityName"
                  value={FormData.facilityName}
                  onChange={handleChange}
                />
              </div>

              <div>
                <label className="text-xs" htmlFor="">
                  Select Icon
                </label>
                <div className="relative w-20 h-20">
                  <img
                    className="w-20 h-20 object-cover rounded-lg"
                    src={
                      FormData.icon ||
                      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT3dSEtDvpd9KAn4SdFJVoL0K1lj4Xfc-wVWQ&s"
                    }
                    alt=""
                  />

                  <div
                    onClick={handleUpload}
                    className="opacity-0 hover:opacity-100 absolute inset-0 bg-black/20 px-3 py-1 border cursor-pointer flex justify-center items-center duration-300 rounded-lg w-20 h-20"
                  >
                    <p className="font-bold text-xs text-white text-center">
                      Upload Now
                    </p>
                  </div>
                </div>
              </div>

              <div className="flex justify-end items-center pt-4 gap-x-4">
                <CancelButton onClick={handleClear} size="sm" text="Cancel" />
                <AddButton
                  onClick={handleSubmit}
                  size="sm"
                  text={FormData.id ? "Edit Facility" : "Add Facility"}
                />
              </div>
            </div>
          </div>

          <div className="flex-1 w-full min-h-0 flex-shrink-0  border  p-3 bg-white rounded-lg">
            <div className="p-4 w-full overflow-x-auto">
              <table className="min-w-full border border-gray-200 bg-white rounded-lg overflow-hidden">
                <thead className="bg-gray-100">
                  <tr>
                    <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                      ID
                    </th>
                    <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                      Icon
                    </th>
                    <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                      Facility Name
                    </th>
                    <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                      Status
                    </th>
                    <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                      Action
                    </th>
                  </tr>
                </thead>

                <tbody className="divide-y divide-gray-200">
                  {FacilityData.length > 0 ? (
                    <>
                      {FacilityData.map((item, index) => {
                        return (
                          <tr key={index} className="hover:bg-gray-50">
                            <td className="px-4 py-3 text-sm text-gray-700">
                              {index + 1}
                            </td>
                            <td className="px-4 py-3 text-sm text-gray-700">
                              <div className="w-7 h-7 overflow-hidden rounded-lg">
                                <img
                                  className="w-full h-full object-contain"
                                  src={item.icon}
                                  alt={item.facilityName}
                                />
                              </div>
                            </td>
                            <td className="px-4 py-3 text-sm text-gray-700">
                              {item.facilityName}
                            </td>
                            <td className="px-4 py-3 text-sm">
                              <span
                                className={`px-2 py-1 ${
                                  item.status === 1
                                    ? "bg-green-100 text-green-700"
                                    : "bg-red-100 text-red-700"
                                } rounded text-xs`}
                              >
                                {item.status === 1 ? "active" : "inactive"}
                              </span>
                            </td>
                            <td className="px-4 py-3 text-sm flex gap-2">
                              <EditButton
                                onClick={() => handleEdit(item)}
                                text="Edit"
                              />
                              <DeleteButton
                                onClick={() => handleDelete(item)}
                                text="Delete"
                              />
                            </td>
                          </tr>
                        );
                      })}
                    </>
                  ) : (
                    <TableLoader colSpan={5} />
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Facilities;
